import users from "../assets/mock/users.json";
import { randCode } from "../helpers/functions";
import { client, clientFd, request } from "./api";

export const login = async (data) => {
  const { id, password } = data;
  return await request.post("auth/signin", { idNumber: id, password });
};

export const signup = async (data) => {
  const payload =
    data.accountType == "PRESTATAIRE"
      ? {
          ...data,
          idType: "REGISTRE_DE_COMMERCE",
          idNumber: data.businessIdNumber,
          businessId: data.businessIdNumber
        }
      : {
          password: data.password,
          email: data.idEmail,
          district: data.idVillage,
          arrondissement: data.idArrondissement,
          commune: data.idCommune,
          department: data.idDepartment,
          idNumber: data.idDeLaCarte,
          idType: data.idType,
          accountType: data.accountType,
          commodities: data.products ?? ["some"],
          firstName: data.idPrenom,
          lastName: data.idNomDeFamille,
          phoneNumber: data.idPhone,
          dateOfBirth: data.idDateDeNaissance,
          gender: data.idSexe,
        };

  console.log(payload, data);

  return payload.accountType === "FARMER"
    ? await request.post("auth/signup", payload)
    : await request.post("auth/newAccount", {...payload, isVerified: false, status: false});
};

export const forgotPassword = async (data) => {
  return await request.post("auth/forgotPassword", data);
};

export const getUserProfile = async () => {
  return await client.get("auth/getMyProfile");
};
export const verifyOtp = async (data) => {
  return await request.post("auth/verifyForgotPasswordOtp", data);
};

export const resetPassword = async (data) => {
  return await request.post("auth/updatePassword", data);
};

export const updateProfile = async (data) => {
  return await client.post("auth/informContact", (data = data));
};
export const updateProfilePicture = async (data) => {
  var bodyFormData = new FormData();
  bodyFormData.append("profile_picture", data);
  return await clientFd.post("auth/profileUpload", (data = bodyFormData));
};
